Bingo.PasswordStrength = Bingo.PasswordStrength || {};

Bingo.PasswordStrength.MIN_ENTROPY = Bingo.PasswordStrength.MIN_ENTROPY || 70;

Bingo.PasswordStrength.messages = Bingo.PasswordStrength.messages || {
    password_strength: 'Password strength',
    short: 'Short',
    weak: 'Weak',
    strong: 'Strong',
};

(function ($, PasswordStrength) {
    $.nette.ext('password-strength', {
        init() {
            const self = this;

            this.ext('snippets', true).after($.proxy(($el) => {
                $el.find('[type="password"].strength').each(function () {
                    self.show($(this));
                });
            }, this));

            $('[type="password"].strength').each(function () {
                self.show($(this));
            });
        },
    }, {
        CATEGORY: {
            SHORT: 'short',
            WEAK: 'weak',
            STRONG: 'strong',
        },
        show($el) {
            const self = this;

            let minLength = null;
            const rules = $el.data('nette-rules');
            if (rules.length) {
                for (let i = 0; i < rules.length; i++) {
                    if (rules[i].op === ':minLength') {
                        minLength = rules[i].arg;
                    }
                }
            }

            const $panel = $('<div>').addClass('password-strength');
            const $rating = $('<span>').addClass('rating').text('');
            const $meter = $('<span>').addClass('');
            $panel.append($('<p>').append($('<span>').text(`${PasswordStrength.messages.password_strength}: `)).append($rating));
            $panel.append($('<div>').addClass('meter').append($meter));

            $el.attr('autocomplete', 'off');

            if ($el.parent().hasClass('input-group')) {
                $panel.insertAfter($el.parent());
            } else {
                $panel.insertAfter($el);
            }

            const callback = function () {
                const category = self.getPasswordCategory($el.val(), minLength);

                $meter.attr('class', category);
                $rating.text(PasswordStrength.messages[category]);
            };

            $el.on('keyup', callback);
            $el.on('change', callback);
            if ($el.val().length > 0) {
                callback();
            }
        },
        /**
         * Category
         * @param password
         * @param minLength
         * @returns {*}
         */
        getPasswordCategory(password, minLength) {
            const entropy = this.getPasswordEntropy(password);

            if (minLength && password.length < minLength) {
                return this.CATEGORY.SHORT;
            }

            if (entropy < PasswordStrength.MIN_ENTROPY) {
                return this.CATEGORY.WEAK;
            }
            return this.CATEGORY.STRONG;
        },
        /**
         * Returns entropy
         * @param password
         * @returns {number}
         */
        getPasswordEntropy(password) {
            const symbols = {
                10: '0-9',
                26: 'a-z',
                36: 'a-z0-9',
                52: 'a-zA-Z',
                63: 'a-zA-Z0-9 ',
                78: 'a-zA-Z0-9 áéíóúýčďěňřšťžů',
                93: 'a-zA-Z0-9 áéíóúýčďěňřšťžůÁÉÍÓÚÝČĎĚŇŘŠŤŽŮ',
                107: '^',
            };

            for (const s in symbols) {
                if (password.match(new RegExp(`^[${symbols[s]}]+$`))) return password.length * Math.log(s) / Math.LN2;
            }

            return 0;
        },
    });
}(jQuery, Bingo.PasswordStrength));
